let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("np2ZB")).then(() => parcelRequire('6i2Ga'));